import React from "react";

import { SWAP_CURVE_DEFINITION_ID } from "./constants";
import { FoNavCurve } from "./FoNavCurve";

interface FoNavSwapsProps {
    startDate: string;
    endDate: string;
}

export function FoNavSwaps({ startDate, endDate }: FoNavSwapsProps): React.ReactElement {
    return (
        <FoNavCurve
            curveDefinitionId={SWAP_CURVE_DEFINITION_ID}
            header="Swaps"
            loadingLabel="swaps"
            startDate={startDate}
            endDate={endDate}
        />
    );
}
